module.exports = __webpack_public_path__ + "web12.png?d091f3b70ca6e80a091812857acc9677";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/photoplio/web12.png
// module id = 68
// module chunks = 0